import React from 'react';
import { connect } from 'react-redux'

import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty, Avatar } from 'antd';
import { CloseCircleOutlined, DownCircleOutlined, EditOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={(row.nama ? row.nama : "-")}
                      avatar={<Avatar src={row.main_path + row.foto} />}
                      description={<>
                        <Row gutter={[8, 8]}>
                          <Col xs={24}>
                            <small>
                              Jenis Tamu: {row.jenis_tamu ? row.jenis_tamu : "-"} <br />
                              Tanggal: {(row.tgl ? row.tgl + " " : "") + (row.nama_lengkap ? row.nama_lengkap : "-") + (row.gelar_belakang ? " " + row.gelar_belakang : "")}<br />
                              Asal Instansi: {row.instansi}<br />
                              Jabatan: {row.jabatan ? row.jabatan : "-"} <br />
                              No.Telp: {row.telepon ? row.telepon : "-"} <br />
                              Alamat: {row.alamat ? row.alamat : "-"} <br />
                              Tujuan: {row.tujuan ? row.tujuan : "-"} <br />
                              Keperluan: {row.keperluan ? row.keperluan : "-"} <br />
                              Keterangan: {row.keterangan ? row.keterangan : "-"} <br />
                            </small>
                          </Col>
                        </Row>
                      </>}

                    />
                    <div>
                      {(!action.update && !action.delete ? "-" : <Dropdown trigger={['click']} menu={{
                        items: [
                          ...(action.update ? [{ key: 1, icon: <EditOutlined />, label: 'Update', onClick: this.props.modalForm.bind(this, true, row) }] : []),
                          ...(action.delete ? [{ key: 2, icon: <CloseCircleOutlined />, label: 'Delete', onClick: this.props.modalDelete.bind(this, true, row) }] : []),
                        ]
                      }}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
